if (!customElements.get('collection-subcategories')) {
  customElements.define(
    'collection-subcategories',
    class CollectionSubcategories extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.subcats__list');
        this.controls = this.querySelector('.subcats__controls');
        this.previous = this.querySelector('.subcats__arrow--previous');
        this.next = this.querySelector('.subcats__arrow--next');
        if (!this.list || !this.controls || !this.previous || !this.next) return;

        this.onPrevious = () => this.scrollByPage(-1);
        this.onNext = () => this.scrollByPage(1);
        this.onScroll = () => this.updateControls();
        this.previous.addEventListener('click', this.onPrevious);
        this.next.addEventListener('click', this.onNext);
        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateControls());
          this.resizeObserver.observe(this.list);
        } else {
          window.addEventListener('resize', this.onScroll);
        }
        this.updateControls();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.previous?.removeEventListener('click', this.onPrevious);
        this.next?.removeEventListener('click', this.onNext);
        this.list?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      scrollByPage(direction) {
        const item = this.list.querySelector('.subcats__item');
        const itemWidth = item?.getBoundingClientRect().width || 0;
        const distance = Math.max(itemWidth, this.list.clientWidth * 0.8);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.list.scrollBy({ left: direction * distance, behavior: reducedMotion ? 'auto' : 'smooth' });
      }

      updateControls() {
        const maxScroll = this.list.scrollWidth - this.list.clientWidth;
        this.controls.hidden = maxScroll <= 2;
        this.list.tabIndex = maxScroll > 2 ? 0 : -1;
        this.previous.disabled = this.list.scrollLeft <= 2;
        this.next.disabled = this.list.scrollLeft >= maxScroll - 2;
      }
    },
  );
}
